/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module VsLogsModule */

import {
    AfterViewInit,
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';

import {
    FilterOperatorType,
    IVsLogsWafRuleGroupsRules,
    IVsLogsWafRuleGroupsSignpostData,
} from 'ng/modules/vs-logs/vs-logs.types';

import { customTemplates, templatesConfiguration } from 'ng/modules/vs-logs/constants/vs-logs-signpost.constants';

import { L10nService } from '@vmw/ngx-vip';
import { IAviDataGridConfig } from 'ng/modules/data-grid';
import * as globalL10n from 'global-l10n';
import { getWafGroupsRequestParams } from 'ng/modules/vs-logs/utils/vs-logs-signpost.utils';
import { VsLogsSignpostStore } from '../../vs-logs-signpost.store';
import './vs-logs-signpost-custom-waf-rule-groups.component.less';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description Signpost component for WAF rule groups section.
 * @author Suraj Kumar
 */
@Component({
    selector: 'vs-logs-signpost-custom-waf-rule-groups',
    templateUrl: './vs-logs-signpost-custom-waf-rule-groups.component.html',
})
export class VsLogsSignpostCustomWafRuleGroupsComponent implements OnInit, AfterViewInit {
    /**
     * TemplateRef for Expanded content of rule group name.
     */
    @ViewChild('expandedContentNameFieldTemplateRef')
    public readonly expandedContentNameFieldTemplateRef: TemplateRef<HTMLElement>;

    /**
     * TemplateRef for rule groups name.
     */
    @ViewChild('nameFieldTemplateRef')
    public readonly nameFieldTemplateRef: TemplateRef<HTMLElement>;

    public readonly FilterOperatorType = FilterOperatorType;

    public wafGroupsGridConfig: IAviDataGridConfig;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(
        public readonly vsLogsSignpostStore: VsLogsSignpostStore,
        private readonly l10nService: L10nService,
    ) {}

    /** @override */
    public ngOnInit(): void {
        const fullSignpostParams = getWafGroupsRequestParams();

        this.vsLogsSignpostStore.getVsLogSignpostData(fullSignpostParams);
    }

    /** @override */
    public ngAfterViewInit(): void {
        const { l10nService } = this;
        const configKey = customTemplates.wafRuleGroups;

        this.wafGroupsGridConfig = {
            layout: {
                hidePagination: true,
                hideCheckboxes: true,
                showFooter: false,
            },
            fields: [
                {
                    label: templatesConfiguration[configKey].name,
                    id: 'name',
                    templateRef: this.nameFieldTemplateRef,
                    expandedTemplateRef: this.expandedContentNameFieldTemplateRef,
                },
                {
                    label: l10nService.getMessage(globalL10nKeys.logsLabel),
                    id: 'logs',
                    transform: (
                        row: IVsLogsWafRuleGroupsSignpostData,
                    ): number => row.count,
                    expandedTransform: (
                        row: IVsLogsWafRuleGroupsRules,
                    ): number => row.count,
                },
            ],
            isExpandedContentColumnBased: true,
        };
    }

    public trackbyIndex(index: number): number {
        return index;
    }
}
